import { Component,OnInit,OnDestroy,AfterViewInit,Input,Output,EventEmitter } from '@angular/core';
import { NgbModal,NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { takeWhile } from "rxjs/operators";
import { forkJoin } from "rxjs";
import { DatePipe } from '@angular/common';
import { format,parse,addDays } from 'date-fns';
import * as FileSaver from 'file-saver';

import {
    FvmsCommonService
    ,FvmsApiCompanyService
    ,FvmsApiAuthService
    ,FvmsApiDtgDownloadService
} from "src/app/shared/service";
import {
    PagingInfo
    ,DtgActionType
    ,DtgListType
} from "src/app/shared/vo";
import {
    DtgManageCarSearchComponent
} from "src/app/dtg/manage/car/search/dtg.manage.car.search.component";
import {
  ModalAlramComponent
} from "../../../../../shared";


@Component({
    selector: "[dtg-manage-etas-file-requst]"
    ,templateUrl: './dtg.manage.etas.file.request.component.html'
    ,providers: [DatePipe]
})
export class DtgManageEtasFileRequestComponent implements OnInit,OnDestroy,AfterViewInit {
    isContinue:boolean = true;
    companyInfo:any;
    currentUserInfo:any;
    listFileCreateHist:any[];
    @Input() listType:DtgListType = DtgListType.list;
    searchValue:string;
    userGroupId:number;
    DtgActionType = DtgActionType;
    DtgListType = DtgListType;
    dtgTeamId:string;
    dtgUnitId:string;
    dtgCarNo:string;
    regDtFrom:string;
    regDtTo:string;

    constructor(
        private modalService: NgbModal
        ,private fvmsCommonService:FvmsCommonService
        ,private fvmsApiAuthService:FvmsApiAuthService
        ,private fvmsApiCompanyService:FvmsApiCompanyService
        ,private fvmsApiDtgDownloadService:FvmsApiDtgDownloadService
        ,private datePipe:DatePipe
    ) {
        this.companyInfo = this.fvmsCommonService.getCompanyInfo();
        this.currentUserInfo = this.fvmsApiAuthService.getLoginUserInfo();
        this.userGroupId = parseInt(this.currentUserInfo.userGroupId);
        if(this.userGroupId > 100){
            this.dtgTeamId = this.currentUserInfo.teamId;
        }
        this.fvmsCommonService.subscribeCompanyInfo()
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(companyInfo => {
                this.companyInfo = companyInfo;
            });
     }

    ngOnInit() {
        let today = new Date();
        today = addDays(today,-1);
        this.regDtFrom = this.datePipe.transform(today,"yyyy-MM-dd");
        this.regDtTo = "" + this.regDtFrom;
    }

    ngOnDestroy() {
        this.isContinue = false;
    }

    ngAfterViewInit() {

    }

    clickSearch(){
        this.reloadListItem();
    }

    changeRegDtFrom(e){
        // console.log("changeRegDtFrom",e);
        this.regDtFrom = e;
    }

    changeRegDtTo(e){
        // console.log("changeRegDtTo",e);
        this.regDtTo = e;
    }

    //검색어 입력란에 엔터키 누르면 실행
    keyupEnterSearchValue(e){
        this.reloadListItem();
    }

    chkSearchDt(){
        let searchDateFrom = parse(this.regDtFrom,'yyyy-MM-dd',new Date());
        let searchDateTo = parse(this.regDtTo,'yyyy-MM-dd',new Date());
        if(searchDateFrom.getTime() > searchDateTo.getTime()){
            let regDtTmp = "" + this.regDtTo;
            this.regDtTo = "" + this.regDtFrom;
            this.regDtFrom = "" + regDtTmp;
        }
    }

    reloadListItem(){
        if(!this.dtgUnitId){
            alert("차량을 먼저 선택 해 주세요");
            return;
        }

        this.chkSearchDt();
        let searchDateFrom = parse(this.regDtFrom,'yyyy-MM-dd',new Date());
        let searchDateTo = parse(this.regDtTo,'yyyy-MM-dd',new Date());

        let listPromise = [];
        while(searchDateFrom.getTime() <= searchDateTo.getTime()){
            let searchInfo = {
                searchDateFrom:format(searchDateFrom,"yyyy-MM-dd")
                ,dtgUnitId:this.dtgUnitId
            };
            let objPromise = this.fvmsApiDtgDownloadService.etasFileRequest(searchInfo);
            listPromise.push(objPromise);
            searchDateFrom = addDays(searchDateFrom,1);
        }
        forkJoin(listPromise)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(listResult => {
                console.log("reloadListItem",listResult);

                let modalAlramRef  = this.modalService.open(
                  ModalAlramComponent
                  ,{
                    centered:true
                    ,size: "sm"
                    ,backdrop:"static"
                    ,scrollable:true
                  }
                )
                modalAlramRef.componentInstance.Context = "E-TAS 파일 생성을 요청 했습니다.";
            });
    }


    clickOpenModalCarSearch(dtgActionType:DtgActionType){

        let modalRef = this.modalService.open(
            DtgManageCarSearchComponent
            ,{
                centered:true
                ,size: "xl"
                ,backdrop:"static"
                //windowClass: "dark-modal"
                ,scrollable: true
            }
        );

        modalRef.result.then((resultModal) => {
            if(resultModal.result === "ok"){
                this.dtgUnitId = resultModal.carInfo.dtgUnitId;
                this.dtgCarNo = resultModal.carInfo.dtgCarNo;
            }
        });
    }

    loadFileCreateHist(){
        this.chkSearchDt();
        let searchInfo = {
            searchDateFrom:this.regDtFrom
            ,searchDateTo:this.regDtTo
            ,dtgUnitId:this.dtgUnitId
        };
        this.fvmsApiDtgDownloadService.etasFileCreateHist(searchInfo)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                if(apiResponse.resultStatus === "ok"){
                    this.listFileCreateHist = apiResponse.resultValue;
                }
            });
    }

    clickSelectFile(itemHist:any){
        let searchInfo = {
            searchDateFrom:itemHist.dtgRegDt
            ,dtgUnitId:itemHist.dtgUnitId
            ,fvmsTripCnt:itemHist.fvmsTripCnt
        };
        this.fvmsApiDtgDownloadService.etasFileDown(searchInfo)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe((apiResponse: Blob) => {
                FileSaver.saveAs(apiResponse,`${itemHist.fileName}`);
            });
    }
}
